/**
 * i18next setup (infra). Two locales — `pl` (source/default) and `en`. Strings
 * live in `locales/*.json` under the default `translation` namespace; migrate
 * hardcoded UI text to `t('area.key')` incrementally.
 *
 * `fallbackLng: 'pl'` means any key not yet translated in `en` renders the
 * Polish text — so partial migration never shows raw keys. Language is detected
 * from localStorage (`rm.lang`) then the browser, and persisted on change.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import pl from './locales/pl.json'
import en from './locales/en.json'

/** Supported language codes; each has a `language.value.<code>.label` in locales. */
export const SUPPORTED_LANGUAGES = ['pl', 'en'] as const

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
      en: { translation: en },
    },
    fallbackLng: 'pl',
    supportedLngs: ['pl', 'en'],
    interpolation: { escapeValue: false }, // React already escapes.
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'rm.lang',
      caches: ['localStorage'],
    },
  })

export default i18n
